import Reveal from "@/components/base/Reveal";

export default function Promo() {
  return (
    <section id="promo" className="scroll-mt-16 bg-[#BFF9EE]">
      <div className="mx-auto max-w-6xl px-4 py-20 md:px-6 md:py-28">
        {/* OLX-style header */}
        <div className="text-center">
          <Reveal delay={100}>
            <h2 className="mt-3 font-heading text-4xl font-extrabold leading-tight tracking-tight promo-gradient-text md:text-6xl">
              Спецпропозиція від OLX Робота
            </h2>
          </Reveal>
        </div>

        {/* Ad banners */}
        <div className="mt-12 grid grid-cols-1 gap-6 md:mt-16 lg:grid-cols-2">
          {/* Banner 1 — new clients */}
          <Reveal delay={100}>
            <div className="group relative h-[420px] overflow-hidden rounded-3xl md:h-[520px]">
              <img
                src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/78cc4af4-132d-46e2-a1fc-efb9960d6aa9_compressed_image-166.webp"
                alt="Новий клієнт OLX Робота — знижка 20%"
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#002f34]/95 via-[#002f34]/55 to-[#002f34]/10" />

              <div className="relative flex h-full flex-col justify-between p-6 md:p-8">
                <span className="text-6xl font-black leading-none tracking-tight text-[#00E9DC] drop-shadow-lg md:text-7xl">
                  -20%
                </span>
                <div>
                  <h3 className="text-2xl font-extrabold leading-tight tracking-tight text-white md:text-3xl">
                    Для нових клієнтів
                  </h3>
                  <p className="mt-2 max-w-sm text-base leading-relaxed text-white/90 md:text-lg">
                    Знижка 20% на всі платні послуги протягом 30 днів
                  </p>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Banner 2 — existing clients */}
          <Reveal delay={200}>
            <div className="group relative h-[420px] overflow-hidden rounded-3xl md:h-[520px]">
              <img
                src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/ad36f0c3-8ade-4b6c-91f1-bcbcdcd42dc9_compressed_image-150.webp"
                alt="Наявні клієнти OLX Робота — CP Pro"
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#002f34]/95 via-[#002f34]/55 to-[#002f34]/10" />

              <div className="relative flex h-full flex-col justify-between p-6 md:p-8">
                <span className="flex items-center gap-2 text-6xl font-black leading-none tracking-tight text-[#00E9DC] drop-shadow-lg md:text-7xl">
                  <i className="ri-vip-crown-line text-5xl text-[#00E9DC] md:text-6xl"></i>
                  CP Pro
                </span>
                <div>
                  <h3 className="text-2xl font-extrabold leading-tight tracking-tight text-white md:text-3xl">
                    Для наявних клієнтів
                  </h3>
                  <p className="mt-2 max-w-sm text-base leading-relaxed text-white/90 md:text-lg">
                    Пакет CP Pro на 3 місяці безкоштовно
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        {/* OLX-style bottom banner / CTA */}
        <Reveal delay={300}>
          <div className="mt-8 flex flex-col items-center gap-3 p-6 text-center md:mt-10 md:px-10 md:py-8">
            <button
              type="button"
              onClick={() => {
                window.location.href = "https://hurma.work/request-2/";
              }}
              className="inline-block shrink-0 whitespace-nowrap rounded-md bg-[#00292D] px-12 py-5 text-lg font-bold text-white transition-colors hover:bg-[#003a40] cursor-pointer"
            >
              Залиште заявку
            </button>
            <p className="text-base text-[#00292D]/75 md:text-lg">
              Покажемо інтеграцію та підкажемо, як скористатися пропозицією
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}